module.exports = __webpack_public_path__ + "img/tooltips_graphic_text_list.2b071c57.webp";